import React from 'react';
import './DashboardWidgets.css';

// DJB-139: reusable widget templates for the Dashboard sections. Two variants
// share one look (title bar + content area, theme-aware card):
//   - "small": one grid cell, a glanceable single stat / compact content
//   - "long":  two fused cells (double width) for richer content
// The stage-2 widgets (DJB-140..147) build on these.

// The shared grid the widgets sit in; the column count adapts to the
// viewport (see DashboardWidgets.css)
export const WidgetGrid = ({ children }) => (
  <div className="widget-grid">{children}</div>
);

// `actions` renders on the right of the title bar — used for widget-level
// controls like the Machines fleet toggle (DJB-143)
export const DashboardWidget = ({ title, variant = 'small', className = '', actions, children }) => (
  <section className={`dashboard-widget dashboard-widget-${variant} ${className}`.trim()}>
    <div className="dashboard-widget-titlebar">
      <h3 className="dashboard-widget-title">{title}</h3>
      {actions && <div className="dashboard-widget-actions">{actions}</div>}
    </div>
    <div className="dashboard-widget-body">{children}</div>
  </section>
);

// Prominent hero value + optional caption — the standard glanceable content
// for a small-square widget, also usable as the lead of a long widget
export const WidgetValue = ({ value, caption }) => (
  <div className="widget-value-group">
    <div className="widget-value">{value}</div>
    {caption && <div className="widget-value-caption">{caption}</div>}
  </div>
);

// Segmented one-of-N picker used for the widget scope controls: the
// time-scope rows (DJB-142 / DJB-147) and the fleet toggle (DJB-143)
export const WidgetScopeControl = ({ label, options, value, onChange }) => (
  <div className="widget-scope-control" role="group" aria-label={label}>
    {options.map((option) => (
      <button
        key={option.key}
        type="button"
        className={`widget-scope-btn ${value === option.key ? 'is-active' : ''}`.trim()}
        aria-pressed={value === option.key}
        onClick={() => onChange(option.key)}
      >
        {option.label}
      </button>
    ))}
  </div>
);
